module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0050.jpg?v=1e1f392b";